import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RouterProvider } from './providers/RouterProvider';
import '@/shared/styles/index.css';
// Importar interceptores después de que axiosClient esté inicializado
import '@/core/api/interceptors';

ReactDOM.createRoot(document.getElementById('root')!).render(
  // TEMPORAL: StrictMode comentado para debugging (causa llamadas duplicadas en dev)
  // TODO: Restaurar antes de producción
  // <React.StrictMode>
  <BrowserRouter>
    <RouterProvider />
  </BrowserRouter>
  // </React.StrictMode>
);

export default {};
